import { render } from "./State.vue?vue&type=template&id=642d96c4&scoped=true"
import script from "./State.vue?vue&type=script&lang=js"
export * from "./State.vue?vue&type=script&lang=js"

import "./State.vue?vue&type=style&index=0&id=642d96c4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642d96c4"],['__file',"src/components/misc/State.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "642d96c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('642d96c4', __exports__)) {
    console.log('reload')
    api.reload('642d96c4', __exports__)
  }
  
  module.hot.accept("./State.vue?vue&type=template&id=642d96c4&scoped=true", () => {
    console.log('re-render')
    api.rerender('642d96c4', render)
  })

}


export default __exports__